module.exports = __webpack_public_path__ + "static/media/Mensaje.3d8b722d.svg";